import React, { useEffect } from 'react';

import { IntlProvider as ReactIntlProvider } from 'react-intl';

import { ChildrenPropType } from '../prop-types/children';
import { LogService } from '../services/log-service';
import { Formatters } from './formatters';
import { useLocale, useMessagesForLocale } from './hooks';
import { English } from './locale-context-provider/locale-codes';
import { changeLocaleForMoment } from './moment-locale';

const DEFAULT_LOCALE = English;
const missingTranslationErrorCode = 'MISSING_TRANSLATION';

const onReactIntlError = (error) => {
  if (error?.code !== missingTranslationErrorCode) {
    LogService.logError(error, { code: error?.code, locale: error?.locale, descriptor: error?.descriptor });
  }
};

export const IntlProvider = ({ children }) => {
  const { locale = DEFAULT_LOCALE } = useLocale();
  const messages = useMessagesForLocale(locale);

  useEffect(() => {
    changeLocaleForMoment(locale);
  }, [locale]);

  return (
    <ReactIntlProvider defaultRichTextElements={Formatters} locale={locale} messages={messages} onError={onReactIntlError}>
      {children}
    </ReactIntlProvider>
  );
};

IntlProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
